import A from 'utils/metrics/analytic'

const A_globalSearch = (txt: string) => {
  A.setEvent('search_use', { searchText: txt })
}

export { A_globalSearch }
